var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4458 25.9766C21.7717 25.9766 22.3449 26.2493 23.1283 27.0998C27.1866 31.5116 31.7487 34.9991 35.5851 37.1045C36.1352 37.4096 36.4426 37.6337 36.4426 37.9249C36.4426 38.1422 36.4125 38.364 35.9318 38.364C35.0698 38.364 30.2326 37.4096 28.9546 36.8087C27.6696 36.2078 24.9056 33.9614 21.6076 28.2807C21.2355 27.6406 20.8403 27.0859 20.8403 26.5705C20.8403 26.0575 21.3095 25.9766 21.4458 25.9766Z",
    fill: "#6C9BD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3995 9.74092C32.3995 9.74092 33.2015 11.3263 25.39 12.4241C26.2404 10.0113 26.8043 8.4236 26.8043 8.4236C27.3012 6.98147 26.1827 6.1333 25.3761 6.1333C24.5672 6.1333 23.9802 6.75267 23.6451 7.53151L21.3224 12.847C18.2764 13.0504 16.0185 12.9441 14.9993 12.8424C13.5826 12.7014 13.2197 13.4872 13.2197 14.2869C13.2197 15.6828 15.6787 17.0995 17.2503 16.9446C18.244 16.8522 18.8195 16.8083 19.6261 16.7274L10.9895 36.4688C10.6613 37.206 10.3956 38.3893 11.877 38.3893C13.3607 38.3893 16.6979 37.0373 17.2549 35.4658C17.4906 34.8048 19.2101 29.9307 21.1283 24.4996C22.0735 24.3101 25.5633 23.7739 26.534 23.7739C27.4538 23.7739 27.9275 24.1876 27.9275 24.6775C27.9275 25.8146 25.2004 29.0756 19.9173 33.0969C19.3349 33.5383 19.8156 33.8873 20.1137 33.8873C20.9295 33.8873 24.5718 31.3913 26.3768 30.0277C28.3597 28.5325 31.8194 24.636 31.8194 21.8996C31.8194 20.818 31.341 19.8289 29.1732 19.8289C27.0724 19.8289 23.3654 20.2957 22.575 20.3974C23.0881 18.9368 23.5965 17.5085 24.068 16.1704C28.1563 15.6042 30.5946 15.2367 32.0297 14.9363C34.0057 14.5157 35.5935 13.3809 35.5935 12.2092C35.5935 9.71319 32.3995 9.74092 32.3995 9.74092Z",
    fill: "#6A2D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/한국투자증권-46.3281f4a0fab4416e7ca435eb58bca917.svg";
export { ForwardRef as ReactComponent };